import * as actions from './actions'
import * as mutations from './mutations'
import * as getters from './getters'
import { AuthState } from '../authentication-model'

export const createInitialState = (): AuthState => ({
  firstName: null,
  tokenIsValid: false,
  passwordLinkIsSending: false,
  newPasswordIsSubmitting: false,
  hasOrcasAccess: false,
  selectedCookies: ['ESSENTIAL']
})

export default {
  state: createInitialState(),
  mutations,
  actions,
  getters
}
